var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgAccount16X16 = function SvgAccount16X16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.682 2.282c3.042-3.043 7.994-3.043 11.036 0 3.043 3.042 3.043 7.994 0 11.036-2 2-4.882 2.726-7.537 2.019l-1.812 1.812a.781.781 0 01-.552.23H10.39v1.427a.779.779 0 01-.229.55l-1.103 1.105a.78.78 0 01-.552.228H7.079v1.427a.776.776 0 01-.229.551l-1.103 1.104a.78.78 0 01-.552.229H.78a.78.78 0 01-.78-.78v-4.414a.78.78 0 01.229-.553L8.663 9.82a7.806 7.806 0 012.019-7.537zm3.525 11.433a6.215 6.215 0 006.407-1.5 6.25 6.25 0 000-8.83 6.252 6.252 0 00-8.828 0 6.218 6.218 0 00-1.502 6.409c.094.28.021.59-.188.8L1.56 19.128v3.31h3.311l.646-.645v-1.884c0-.431.35-.781.78-.781h1.885l.646-.646v-1.884c0-.432.35-.78.78-.78h1.884l1.914-1.914a.78.78 0 01.8-.189zm.888-9.227a3.125 3.125 0 014.415 0 3.127 3.127 0 010 4.415 3.125 3.125 0 01-4.415 0 3.127 3.127 0 010-4.415zm1.103 3.31a1.561 1.561 0 102.208-2.208 1.561 1.561 0 00-2.207 2.209z",
    fill: "#9CA6AD"
  })));
};

export default SvgAccount16X16;